import { t as c } from "./morphNodes-D-0jCzKf.js";
import { n as h, t as d } from "./personalization-CyiAV07Q.js";
var S = () => ({
  productSoldOut: !1,
  hasRequired: !0,
  get soldOutLabel() {
    return window.NewThink?.SOLD_OUT_LABEL ?? "";
  },
  checkRequired(e) {
    const t = new FormData(e);
    this.hasRequired = e.elements.toArray().filter((i) => i instanceof HTMLInputElement || i instanceof HTMLSelectElement || i instanceof HTMLTextAreaElement).filter((i) => i.required && i.name?.endsWith("[id]")).map((i) => t.get(i.name)).every((i) => i && i !== "null");
  },
  init() {
    const e = this.$el.querySelector("form[action='/cart/add']:not(.payment-terms)");
    e?.addEventListener("change", () => {
      this.checkRequired(e);
    }, { signal: this.$abortSignal }), e && this.checkRequired(e);
    const t = () => {
      this.changeVariant(window.location.href);
    };
    this.$store.cart.addEventListener("close", t), this.$abortSignal.addEventListener("abort", () => this.$store.cart.removeEventListener("close", t));
  },
  changeVariant: u
}), u = async (e) => {
  console.log("Replacing page with:", e);
  const t = new URL(e, window.location.origin);
  window.history.replaceState({}, "", t);
  const i = await (await fetch(t)).text();
  if (!i) {
    console.error("Failed to fetch the new variant page:", e);
    return;
  }
  const r = Array.from(document.querySelectorAll('main > [id^="shopify-section"]'), (n) => `#${n.id}`);
  if (!r.length) {
    console.warn("No sections found for variant change");
    return;
  }
  c(i, r);
}, P = () => ({
  submitting: !1,
  async handleSubmit(e) {
    if (window.NewThink?.ACCESS_GATE_CAN_BUY === !1) {
      window.location.href = window.NewThink.ACCESS_GATE_LOGIN_URL ?? "/account/login";
      return;
    }
    if (e.reportValidity()) {
      this.submitting = !0;
      try {
        const t = await m(e), i = new CustomEvent("product-form-submit", {
          detail: {
            action: e.action,
            method: e.method,
            data: t
          },
          cancelable: !0,
          bubbles: !0
        });
        if (document.dispatchEvent(i), i.defaultPrevented && !await i.detail.proceed) {
          console.warn("Product Form Submission Blocked");
          return;
        }
        const r = await fetch(e.action + ".js", {
          method: e.method,
          ...h(t)
        });
        if (!r.ok) {
          console.error("Failed to submit form:", r.statusText);
          return;
        }
        this.$dispatch("product-added", { qty: Number(t.get("items[0][quantity]") ?? 1) }), this.$store.cart.isOpen ? this.$store.cart.load() : this.$store.cart.open(), this.changeVariant?.(window.location.href);
      } finally {
        this.submitting = !1;
      }
    }
  }
}), m = async (e) => {
  const t = new FormData(e);
  b(t), t.has("items[0][properties][_bundle_parent]") && await p(t), f(t), g(t);
  const i = Array.from(e.elements).find((r) => r.id.startsWith("product-notes-"));
  return i?.value && Array.from(t.entries()).filter(a("[id]")).map(o("[id]")).map(v(i.name.match(/\[properties\]\[.+\]/)?.[0])).forEach((r) => {
    t.append(r, i.value);
  }), d(t), t;
}, p = async (e) => {
  const t = Array.from(e.entries()).filter(a("[id]")).map(([n, s]) => s).map(String), i = await w(t.filter((n) => n !== "" && n !== "null")), r = parseInt(e.get("items[0][quantity]")) || 1;
  t.forEach((n, s) => {
    n === "" || n === "null" ? Array.from(e.keys()).filter(l(`items[${s}]`)).forEach(e.delete.bind(e)) : (e.append(`items[${s}][properties][_bundle_id]`, i), e.has(`items[${s}][quantity]`) || e.append(`items[${s}][quantity]`, r.toString()));
  });
}, f = (e) => {
  Array.from(e.entries()).filter(a("[quantity]")).filter(([t, i]) => i === "0").map(o("[quantity]")).forEach((t) => Array.from(e.keys()).filter(l(t)).forEach(e.delete.bind(e)));
}, g = (e) => {
  const t = e.get("selling_plan"), i = Array.from(e.keys()).filter((r) => /^items\[\d+\]\[id\]$/.test(r)).map((r) => r.slice(0, -4));
  t !== null && i.length > 0 && (e.delete("selling_plan"), t !== "" && i.forEach((r) => e.set(`${r}[selling_plan]`, String(t))));
}, q = () => ({
  controller: new AbortController(),
  hasQuantity: !1,
  quantity: 1,
  unitPrice: 0,
  priceBreaks: [],
  planPrices: {},
  sellingPlanId: "",
  priceDelimiter: "",
  isBundle: !1,
  bundleItems: [],
  personalizationPrice: 0,
  observer: null,
  init() {
    const e = this.$el.form;
    console.assert(e, "LockedATC must be initialized on a button in a form");
    const t = this.$dataset;
    if (this.unitPrice = Number(t.unitPrice) || 0, this.priceDelimiter = t.priceDelimiter ?? "", this.isBundle = t.isBundle === "true", this.priceBreaks = JSON.parse(t.priceBreaks || "[]").sort(([i], [r]) => i - r), this.planPrices = Object.fromEntries(JSON.parse(t.planPrices || "[]")), e?.addEventListener("change", () => {
      this.$nextTick(() => this.checkQuantity(e));
    }, { signal: this.controller.signal }), e?.addEventListener("personalization-change", (i) => {
      this.personalizationPrice = Number(i.detail?.price) || 0;
    }, { signal: this.controller.signal }), e) {
      this.checkQuantity(e), this.$nextTick(() => this.checkQuantity(e));
      const i = () => requestAnimationFrame(() => this.checkQuantity(e));
      document.addEventListener("click", i, { signal: this.controller.signal }), document.addEventListener("input", i, { signal: this.controller.signal }), this.observer = new MutationObserver(i), this.observer.observe(e, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["value"]
      });
    }
    this.isBundle && (document.addEventListener("bundle-option-change", (i) => {
      const { index: r, price: n } = i.detail ?? {};
      this.bundleItems[Number(r) || 0] = Number(n) || 0;
    }, { signal: this.controller.signal }), this.$nextTick(() => this.$dispatch("request-option-prices")));
  },
  checkQuantity(e) {
    const t = new FormData(e);
    this.quantity = Number(t.get("items[0][quantity]")) || 1, this.sellingPlanId = String(t.get("items[0][selling_plan]") ?? t.get("selling_plan") ?? "");
    const i = Array.from(t.entries()).filter(([r]) => r.endsWith("[quantity]"));
    if (i.length === 0) {
      this.hasQuantity = !0;
      return;
    }
    this.hasQuantity = i.map(([, r]) => Number(r)).some((r) => r > 0);
  },
  get atcUnitPrice() {
    if (this.isBundle) return this.bundleItems.reduce((t, i) => t + (i || 0), 0);
    const e = this.planPrices[this.sellingPlanId];
    return e || this.priceBreaks.reduce((t, [i, r]) => this.quantity >= i ? r : t, this.unitPrice);
  },
  atcPriceText(e = !0) {
    if (this.isBundle && (!e || this.bundleItems.length === 0)) return "";
    const t = this.$formatMoney((this.atcUnitPrice + this.personalizationPrice) * Math.max(this.quantity, 1) / 100);
    return t ? ` ${this.priceDelimiter} ${t}` : "";
  },
  destroy() {
    this.controller.abort(), this.observer?.disconnect();
  }
}), y = [
  "[Send on]",
  "[Message]",
  "[selling_plan]"
], b = (e) => {
  Array.from(e.entries()).filter(a(y)).filter(([t, i]) => i === "").forEach(([t]) => e.delete(t));
}, a = (e) => ([t]) => Array.isArray(e) ? e.some((i) => t.endsWith(i)) : t.endsWith(e), o = (e) => ([t]) => Array.isArray(e) ? e.reduce((i, r) => i.endsWith(r) ? i.slice(0, -r.length) : i, t) : t.endsWith(e) ? t.slice(0, -e.length) : t, v = (e = "") => (t) => t + e, l = (e) => (t) => t.startsWith(e), w = async (e) => {
  const t = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(e.toSorted().join("-")));
  return Array.from(new Uint8Array(t)).map((i) => i.toString(16).padStart(2, "0")).join("");
};
export {
  q as LockedATC,
  P as ProductForm,
  S as ProductMain,
  S as default
};
